export interface LaunchUser {
  id: number
  first_name: string
  last_name?: string
  username?: string
  language_code?: string
  is_premium?: boolean
  allows_write_to_pm?: boolean
}

export interface LaunchParams {
  initData: string
  platform: string | null
  tgVersion: string | null
  user: LaunchUser | null
  startParam: string | null
}

function parseHashParams(): URLSearchParams {
  const hash = window.location.hash
  if (!hash || hash.length <= 1) {
    return new URLSearchParams()
  }
  return new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash)
}

function parseInitDataFields(initData: string): { user: LaunchUser | null; startParam: string | null } {
  if (!initData) {
    return { user: null, startParam: null }
  }

  try {
    const params = new URLSearchParams(initData)
    const userStr = params.get('user')
    const startParam = params.get('start_param')

    let user: LaunchUser | null = null
    if (userStr) {
      user = JSON.parse(userStr) as LaunchUser
    }

    return { user, startParam }
  } catch {
    return { user: null, startParam: null }
  }
}

/**
 * Извлекает launch-параметры Telegram из location.hash.
 * Работает даже если telegram-web-app.js не загрузился — initData лежит в tgWebAppData.
 */
export function getLaunchParamsFromHash(): LaunchParams {
  const hashParams = parseHashParams()
  const initData = hashParams.get('tgWebAppData') || ''
  const platform = hashParams.get('tgWebAppPlatform')
  const tgVersion = hashParams.get('tgWebAppVersion')
  const { user, startParam } = parseInitDataFields(initData)

  return {
    initData,
    platform,
    tgVersion,
    user,
    startParam,
  }
}

/** initData из WebApp API или fallback из hash */
export function resolveInitData(webAppInitData?: string): string {
  if (webAppInitData) return webAppInitData
  return getLaunchParamsFromHash().initData
}

/** Есть ли признаки запуска внутри Telegram (WebApp API или hash) */
export function isTelegramLaunch(): boolean {
  if (window.Telegram?.WebApp) return true
  const fromHash = getLaunchParamsFromHash()
  return !!fromHash.initData
}
